import styled from "styled-components";

// Linha que organiza o título ou seções da página
export const Line = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 0;
    padding: 0 16px;
    border-bottom: 1px solid #ddd;
    font-size: 1rem;

    & .first {
        font-weight: bold;
        font-size: 1.2rem;
    }
`;

// Container genérico que pode ser usado em diálogos
export const ContainerBox = styled.div`
    padding: 16px;

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }
`;

export const PageTitle = styled.h1`
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin: 0;
    padding: 16px 0;
`;

export const QuantityInput = styled.input`
    width: 100%;
    padding: 5px;
    margin-top: 5px;
    font-size: 14px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.3s;

    &:focus {
        border-color: #1976d2; /* Cor primária do Material-UI */
        box-shadow: 0 0 4px rgba(25, 118, 210, 0.5); /* Efeito de foco */
    }

    &:hover {
        border-color: #999;
    }
`;
